// extracted by mini-css-extract-plugin
module.exports = {"tosPdf":"ProductDetailTOS_tosPdf_icnZ3"};